import React, { useEffect, useState } from 'react';

import SupportUsersTable from './SupportUsersTable';

export default function SupportUsers(props) {
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = () => {
        axios
            .get(props.listRolesUrl)
            .then((res) => {
                const { roles } = res.data;
                setRoles(roles);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    if (roles.length === 0) {
        return <div>{$t('Loading...')}</div>;
    }

    return (
        <SupportUsersTable
            roles={roles}
            usersUrl={props.usersUrl}
            inviteUrl={props.inviteUrl}
            revokeUrl={props.revokeUrl}
            canCreate={props.canCreate}
            type={props.type}
            organisationSupportUsersUrl={props.organisationSupportUsersUrl || null}
        />
    );
}
